import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';
import { ToastType } from './interface';

interface StyleProps {
  type: ToastType ;
}

export const useStyles = makeStyles<ITheme, StyleProps>((theme) => ({
  mainContainer: {
    color: ({ type }) => type === ToastType.INFO ? colors.darkestGray : colors.white,
    paddingLeft: 24,
    paddingRight: 24,
    paddingBottom: 40,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  contentWrapper: {
    width: '400px',
    padding: 16,
    backgroundColor: ({ type }) => type === ToastType.INFO ? colors.darkYellow : colors.darkBlue,
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      width: 'auto',
      margin: '0 16px',
    },
  },
  top: {
    display: 'flex',
    flexDirection: 'row',
  },
  content: {
    paddingBottom: 12,
  },
  icon: {
    width: 22,
    height: 22,
    marginRight: 16,
  },
  buttonsWrapper : {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: 'auto',
  },
  button: {
    alignSelf: 'end',
    fontWeight: 'bold',
    color: ({ type }) => type === ToastType.INFO ? colors.darkestBlue : colors.white,
  },
}));
